import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component'
import { Link } from 'react-router-dom'
import axiosAuthInstance from '../../utils/axios/axiosAuthInstance'
import { FiEdit2, FiTrash2 } from 'react-icons/fi'
import { MdOutlineClose } from 'react-icons/md'
import { RiAlertFill } from 'react-icons/ri'
import columns from './columns'
import CustomModal from '../../components/common/CustomModal'

const Material = () => {
  const [data, setData] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isDeleteLoading, setIsDeleteLoading] = useState(false)
  const [selectedColor, setSelectedColor] = useState(null)
  const [pages, setPages] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalRows, setTotalRows] = useState(0)

  const fetchData = async () => {
    try {
      const response = await axiosAuthInstance.get('color/list', {
        page: pages, limit: limit
      })
      if (response.status === 200) {
        const transformedData = response?.data?.result?.docs?.map((item) => ({
          ...item,
          actions: (
            <div className='flex items-center'>
              <div
                className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'
                onClick={() => handleOpenDeleteModal(item._id)}
              >
                <FiTrash2 className='w-4 h-4' />
              </div>
              <div className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'>
                <Link to={`edit/${item._id}`}>
                  <FiEdit2 className='w-4 h-4' />
                </Link>
              </div>
            </div>
          ),
        }))
        setData(transformedData)
        setTotalRows(response.data.result.totalDocs)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [pages, limit])

  const handleOpenDeleteModal = (id) => {
    setSelectedColor(id)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setSelectedColor(null)
  }

  const handleDelete = async (id) => {
    setIsDeleteLoading(true)
    try {
      const response = await axiosAuthInstance.delete(
        `color/delete/${selectedColor}`,
      )
      if (response.status === 200) {
        fetchData()
        setIsDeleteLoading(false)
        setIsModalOpen(false)
      }
    } catch (error) {
      setIsModalOpen(false)
      setIsDeleteLoading(false)
    }
  }

  const handlePageChange = (newPage) => {
    setPages(newPage)
  }

  const handleLimitPerPageChange = (newLimit) => {
    setLimit(newLimit)
    setPages(1)
  }


  return (
    <div>
      <div className='flex items-center justify-between border-b px-4 pb-2'>
        <h1 className='text-2xl'>Color</h1>
        <Link to='/color/add'>
          <button className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'>
            Add
          </button>
        </Link>
      </div>

      <DataTable
        columns={columns}
        data={data}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={limit}
        paginationRowsPerPageOptions={[10, 20, 30]}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleLimitPerPageChange}
      />

      {isModalOpen && (
        <CustomModal handleCloseModal={handleCloseModal}>
          <div className='p-4 relative'>
            <div
              className=' absolute right-5 cursor-pointer hover:opacity-70'
              onClick={handleCloseModal}
            >
              <MdOutlineClose className=' text-2xl' />
            </div>
            <div className=' flex flex-col items-center justify-between gap-4'>
              <div className='flex flex-wrap justify-center alert-ico'>
                <RiAlertFill className=' text-5xl' />
              </div>
              <h2>Are you sure you want to delete this Color?</h2>
              <div className='flex gap-4 mt-4'>
                <button
                  onClick={handleCloseModal}
                  className='bg-gray-300 px-4 py-2 rounded'
                >
                  No, Cancel
                </button>
                <button
                  onClick={handleDelete}
                  className='bg-red-500 text-white px-4 py-2 rounded'
                >
                  {isDeleteLoading ? (
                    <div className='w-5 h-5 mx-auto border-2 border-white border-solid rounded-full loader animate-spin border-t-transparent' />
                  ) : (
                    "Yes, I'm sure"
                  )}
                </button>
              </div>
            </div>
          </div>
        </CustomModal>
      )}
    </div>
  )
}

export default Material
